<template>
  <div class="appplyinfocon">
    <div class="node lp-question">
      <div class="lp-question--title">
        <strong>请您填写真实信息</strong>
      </div>
      <div class="cells-form">
        <div class="lp-question-form">
          <div class="cells-title">手机号</div>
          <div class="cells-bd">
            <div>
              <input
                type="tel"
                @focus="setTxtArea"
                placeholder="手机号"
                maxlength="11"
                v-model="mobilenumber"
                @blur="checkmobile"
                class="lp-question-input"
              />
            </div>
            <div
              class="errorinfo"
              v-if="errinfo.sidPhone"
            >！{{errinfo.sidPhone}}</div>
          </div>
        </div>
        <div class="lp-question-form">
          <div class="cells-title">验证码</div>
          <div class="cells-bd vercode">
            <div class="input-box">
              <input
                type="tel"
                v-model="smsCode"
                maxlength="6"
                @focus="setTxtArea"
                placeholder="填写验证码"
                class="lp-question-input"
              />
              <button
                :class="wait==60&&ismobile ? 'seed' : ''"
                @click="sendVerifyCode"
              >{{wait==60 ? '获取验证码' : wait+'秒后重试'}}</button>
            </div>
            <div
              class="errorinfo"
              v-if="errinfo.sidCode"
            >！{{errinfo.sidCode}}</div>
          </div>
        </div>
        <div class="lp-question-form">
          <div class="cells-title">身份证</div>
          <div class="cells-bd">
            <div>
              <input
                type="text"
                pattern="[0-9Xx]*"
                maxlength="18"
                @focus="setTxtArea"
                v-model="sqridcard"
                placeholder="请填写您的身份证号码"
                class="lp-question-input"
              />
            </div>
            <div
              class="errorinfo"
              v-if="errinfo.sidCard"
            >！{{errinfo.sidCard}}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="button"
      :class="ismobile&&isSmsCode&&isidcard ? 'seed' : ''"
      @click="submit"
    >下一步</div>
  </div>
</template>
<script>
import idCard from 'idcard'
import { checkSMS } from '../datas/js/common.js'
export default {
  props: {
    url: {
      type: String, // 路由
      default: ''
    }
  },
  data () {
    return {
      wait: 60,
      mobilenumber: '',
      smsCode: '',
      errinfo: {
        sidPhone: '',
        sidCode: '',
        sidCard: ''
      },
      ismobile: false,
      isSmsCode: false,
      isidcard: false,
      sqridcard: '',
      alert: {
        // 提示内容
        show: false,
        info: '',
        recall: () => { }
      },
      gender: ''
    }
  },
  mounted () {
    this.$store.commit('user/setWechatUinfo', {})
  },
  methods: {
    setTxtArea () {
      window.addEventListener('resize', function () {
        if (document.activeElement.tagName === 'TEXTAREA' || document.activeElement.tagName === 'INPUT') {
          document.activeElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },
    checkmobile () {
      if (!this.mobilenumber.length) {
        this.errinfo.sidPhone = '请填写手机号'
      } else {
        let reg = /^1[0-9]{10}$/
        const phoneInfo = reg.test(this.mobilenumber) // 验证手机号
        console.log(phoneInfo, 'phoneInfo')
        if (!phoneInfo) {
          this.errinfo.sidPhone = '手机号格式错误'
        } else {
          this.errinfo.sidPhone = ''
          this.ismobile = true
        }
      }
    },
    // 发送短信
    async sendVerifyCode () {
      if (this.wait !== 60 && this.ismobile === true) {
        return
      }
      const { status, msg, results } = await this.$post(
        `/api/services/sms/send/${this.mobilenumber}/?web_no_login=c14ad1b1d34ad244`
      )
      console.log(results)
      if (!status) {
        this.errinfo.sidCode = msg
      }
      this.time()
    },
    time () {
      if (this.wait === 0) {
        this.wait = 60
      } else {
        this.wait--
        setTimeout(() => this.time(), 1000)
      }
    },
    async submit () {
      if (!(this.ismobile && this.isSmsCode && this.isidcard)) {
        return
      }
      if (!this.sqridcard) {
        this.errinfo.sidCard = '请填写身份证号'
        return
      }
      const { result, msg, status } = await this.$get(
        `https://yn.12348.laway.cn/api/gei/terminal/user/info/?idcard=${this.sqridcard}`
      )
      if (!status) {
        console.log(msg)
        // 获取信息没有就创建
        await this.setWechatUid()
      } else {
        this.$store.commit('user/setWechatUinfo', result.user_info)
        this.$router.push(this.url)
      }
    },
    async setWechatUid () {
      const data = {
        idcard: this.sqridcard,
        truename: '',
        mobile: this.mobilenumber,
        areacode: this.$store.state.device.point.code,
        gender: this.gender
      }
      const res = await this.$post(
        `https://yn.12348.laway.cn/api/creat/terminal/user/`,
        { ...data }, '', '', true
      )
      if (!res.status) {
        console.log(res.msg)
        this.alert.info = '请联系工作人员'
        this.alert.show = true
        return
      }
      console.log(res.result.user_info)
      this.$store.commit('user/setWechatUinfo', res.result.user_info)
      this.$router.push(this.url)
    }
  },
  watch: {
    mobilenumber (val) {
      val = val.replace(' ', '')
      let checknum = /^[0-9]*$/
      for (let char of this.mobilenumber) {
        if (!checknum.test(char)) {
          this.mobilenumber = this.mobilenumber.replace(char, '')
        }
      }
      if (val.length) {
        this.errinfo.sidPhone = ''
      }
      if (!val.length) {
        this.errinfo.sidPhone = '请填写手机号'
      }
      let reg = /^1[0-9]{10}$/
      if (this.mobilenumber.length === 11) {
        const phoneInfo = reg.test(val) // 验证手机号
        console.log(phoneInfo, 'phoneInfo')
        if (!phoneInfo) {
          this.errinfo.sidPhone = '手机号格式错误'
        } else {
          this.errinfo.sidPhone = ''
          this.mobilenumber = val
          this.ismobile = true
        }
      }
    },
    async smsCode (val) {
      val = val.replace(' ', '')
      let checknum = /^[0-9]*$/
      for (let char of this.smsCode) {
        if (!checknum.test(char)) {
          this.smsCode = this.smsCode.replace(char, '')
        }
      }
      if (!val.length) {
        this.errinfo.sidCode = '请输入6位短信验证码'
      }
      if (val.length === 6) {
        const verSms = checkSMS(val)
        // 验证码错误
        if (!verSms[0]) {
          this.errinfo.sidCode = verSms[1]
        }
        const { status, msg, results } = await this.$get(
          `/api/services/sms/check/${this.mobilenumber}/?captcha=${this.smsCode}`
        )
        console.log(results)
        if (!status) {
          this.errinfo.sidCode = msg
        } else {
          this.isSmsCode = true
        }
      } else {
        this.errinfo.sidCode = ''
      }
    },
    sqridcard (val) {
      val = val.replace(' ', '')
      let checknum = /^[0-9Xx]*$/
      for (let char of this.sqridcard) {
        if (!checknum.test(char)) {
          this.sqridcard = this.sqridcard.replace(char, '')
        }
      }
      if (val.length === 18) {
        const cardInfo = idCard.info(val)
        console.log(cardInfo, 'cardInfo')
        if (!cardInfo.valid) {
          this.errinfo.sidCard = '身份证号格式错误'
        } else {
          this.errinfo.sidCard = ''
          this.gender = cardInfo.gender === 'M' ? 1 : 2
          this.isidcard = true
        }
      } else {
        this.errinfo.sidCard = ''
      }
    }
  }
}
</script>
<style lang="stylus">
.appplyinfocon
  .lp-question-form
    .cells-bd
      position relative
      .errorinfo
        position absolute
        bottom -0.12rem
        line-height 1.1
        font-size 0.2rem
        color red
      .input-box
        display flex
        input
          flex 1
          border-right 0
          border-radius 0.08rem 0 0 0.08rem
        button
          border-radius 0 0.08rem 0.08rem 0
          padding 0 0.3rem
          background #ccc
          color #fff
          font-size 0.3rem
          border 0
          &.seed
            background #fc9d0b
  .title
    font-size 0.3rem
    line-height 0.3rem
    padding-bottom 0.56rem
    letter-spacing 1px
  .button
    display block
    margin 0.6rem auto 0 auto
    width 2.78rem
    text-align center
    height 0.9rem
    line-height 0.9rem
    border 0
    color #fff
    background #ccc
    border-radius 0.1rem
    font-size 0.28rem
    &.seed
      background-color #fc9d0b
</style>
